import React, {FC, useContext, useEffect, useState} from 'react'
import BlankPage from "Components/Layout/BlankPage";
import {UserContext} from "Vendor/Context/UserContextProvider";
import {BannerContext} from "Vendor/Context/BannerContextProvider";
import User from "Entity/User";
import Dropzone from "Components/Dropzone";

const BimboSharePage: FC = () => {
    const { currentUser, setCurrentUser } = useContext(UserContext);
    const { setBanner } = useContext(BannerContext);
    const [files, setFiles] = useState<string[]>([])

    useEffect(() => {
        if (currentUser?.currentOrganization?.bimboShareCover) {
            setFiles([currentUser?.currentOrganization?.bimboShareCover])
        } else {
            setFiles([])
        }
    }, [currentUser])

    const onUploadSuccess = (data: User) => {
        setBanner({type: 'success', i18nTitle: 'app.save', i18nMessage: 'app.upload_success_message'})
        setCurrentUser(data)
    }

    if (!currentUser || !currentUser.currentOrganization) return <></>

    return (
        <BlankPage>
            <Dropzone
                uploadPath="/admin/edition/setting/upload-bimboshare-cover"
                deletePath="/admin/edition/setting/remove-bimboshare-cover"
                files={files}
                setFiles={setFiles}
                multiple={false}
                label="Cover"
                onSuccess={onUploadSuccess}
            />
        </BlankPage>
    )
}

export default BimboSharePage
